import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 5rem 3.2rem 1.2rem;
  width: 123rem;
  overflow-y: auto;

  .complaint-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 0.4rem;
  }

  .complaint-client {
    color: ${(props) => props.theme.colors.black};
    font-size: 2.4rem;
    font-weight: 700;
    margin-bottom: 0.8rem;
  }
`;

export const GrayDiv = styled.div`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.2rem;
`;

export const StepContent = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
`;

export const StepsBar = styled.div`
  margin-left: 1rem;
  user-select: none;

  .step-name {
    ${({ theme }) => `
      font-family: ${theme.fontFamilies.primaryFont}
    `}
    color: ${(props) => props.theme.colors.blackTextTitle};
    font-style: normal;
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 2.1rem;
    margin-right: 2rem;
    margin-left: 1rem;
    margin-top: auto;
    margin-bottom: 5rem;
  }

  .step-tabs {
    display: flex;
    justify-content: flex-start;
    margin-top: 2rem;
  }

  h1 {
    color: ${({ theme }) => theme.colors.blackBlue + theme.transparencies.p58};

    font-size: 1.2rem;
    font-style: normal;
    font-weight: bold;
    height: 1.4rem;
    margin-left: 1rem;
    margin-top: 5.5rem;
    width: auto;
  }
  .arrowIcon {
    display: flex;
    margin-right: 0rem;
    margin-left: 1rem;
  }
`;

interface IStepDescription {
  isCurrent?: any;
}
export const StepDescription = styled.div<IStepDescription>`
  ${({ isCurrent, theme }) => {
    const color = isCurrent ? theme.colors.blackTextTitle : theme.colors.gray;
    return `
      color: ${color};
      font-family: ${theme.fontFamilies.primaryFont};
    `;
  }};

  display: flex;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: bold;
  line-height: 1.8rem;
  margin-left: 1rem;
  margin-top: 0.1rem;
  width: 20rem;
`;

interface IStepNumber {
  activated?: any;
}
export const StepNumber = styled.button<IStepNumber>`
  ${({ activated, theme }) => `
    background-color: ${
      activated
        ? theme.colors.primaryBlue
        : theme.colors.gray + theme.transparencies.p20
    };
    color: ${theme.colors.white};
    font-family: ${theme.fontFamilies.primaryFont};
  `}

  align-items: center;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 700;
  height: 3rem;
  justify-content: center;
  width: 3rem;
`;

export const StatusSection = styled.div`
  display: flex;
  margin-top: 1.6rem;
  position: relative;

  .status-tag {
    width: 11rem;
  }

  .expand-status {
    align-items: center;
    cursor: pointer;
    display: flex;

    img {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .tooltip {
    align-items: center;
    display: flex;
    flex-direction: column;
    top: 90%;
    width: 13.5rem;
  }
`;
